define('models/pages/news/news',[
    'underscore',
    'chaplin',
    'models/base/model',
    'models/base/collection'
], function(_, Chaplin, Model, Collection) {
    'use strict';

    var NewsItem = Model.extend({
        defaults: {
            ID: 0,
            NewsDate: new Date(),
            tags: [],
            Published: true,
            stateName: '',
            PhotoUrl: null,
            Header: '',
            ShortDescription: ''
        }
    });

    var NewsItemsCollection = Collection.extend({
        model: NewsItem,
        initialize: function() {
            Chaplin.Collection.prototype.initialize.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        }
    });

    var TagItem = Model.extend({
        defaults: {
            ID: 0,
            Name: '',
            count: 0,
            fontSize: 0,
            selected: false
        }
    });

    var TagsItemsCollection = Collection.extend({
        model: TagItem
    });

    var NewsPageModel = Model.extend({
        urlPath: '/page/news/list',
        defaults: {
            tag: '',
            tags: [],
            items: []
        },
        TAG_FONT_SIZE_MIN: 12,
        TAG_FONT_SIZE_MAX: 25,
        ALL_TAG_NAME: 'Все',

        constructor: function() {
            this.items = new NewsItemsCollection([]);
            this.tags = new TagsItemsCollection([]);

            Model.apply(this, arguments);

            var items = this.items;

            this.on('beforeLoad', function() {
                items.beginSync();
            });

            this.on('afterLoad', function() {
                items.finishSync();
            });
        },

        _preprocessNews: function(items){
            _.each(items, function(item){
                item.tags = item.tags ? item.tags.split(',') : [];
            });
            return items;
        },

        _preprocessTags: function(items, newsMaxTagCount){

            var _this =this;
            var tagName = this.get('tag');

            function fontSize(tagCount, newsMaxTagCount){
                var count = tagCount > newsMaxTagCount ? newsMaxTagCount : tagCount;
                var p = (count*100)/newsMaxTagCount;
                p = ((_this.TAG_FONT_SIZE_MAX - _this.TAG_FONT_SIZE_MIN)*p)/100 + _this.TAG_FONT_SIZE_MIN;
                return p;
            }

            _.each(items, function(tag){
                tag.fontSize = fontSize(tag.count, newsMaxTagCount);
                tag.selected = tag.Name === tagName;
            });

            items.unshift({
                ID: -1,
                Name: this.ALL_TAG_NAME,
                count: 0,
                fontSize: fontSize(newsMaxTagCount/2, newsMaxTagCount),
                selected: tagName === ''
            });

            return items;
        },

        parse: function(data){
            this.items.reset(this._preprocessNews(data.news) || [], { silent: true });
            this.tags.reset(this._preprocessTags(data.tags || [], data.newsMaxTagCount || 1), { silent: true });
        },

        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);

            params.tag = this.get('tag');
            return params;
        }
    });

    return NewsPageModel;
});
